export default __webpack_public_path__ + "static/media/move.d7ec9fce.svg";